import React from "react"
import { Label } from "ui/components/atoms/typography"

const PlatformLink = ({ status, to }: { status: boolean; to: string }) => {
  if (status) {
    return (
      <a href={`${process.env.REACT_APP_DOMAIN}${to}`} target="_blank" rel="noreferrer">
        <Label $type="third" $color="primary">
          {`${process.env.REACT_APP_DOMAIN}${to}`}
        </Label>
      </a>
    )
  }
  return (
    <Label $type="third" $color="red">
      {`${process.env.REACT_APP_DOMAIN}${to}`}
    </Label>
  )
}

export default PlatformLink
